/* eslint jsx-a11y/label-has-associated-control: 0 */
import React from 'react'

import Icon from '../../../../components/icon'
import { useOrder } from '../../../../contexts/order'
import { ServiceCharge } from '../../../../enums/stablishment-tables'
import OrderPad from '../order-pad'
import {
  Overlay,
  Modal,
  CloseButton,
  Header,
  SubmitButton,
} from './styles'

const CloseOrderPadModal = () => {
  const {
    currentOrderPadCard,
    orderPadIsOpen,
    setOrderPadIsOpen,
    amountCustomer,
    handlePayOrderPad,
    serviceChargeType,
    isLoadingBilling,
  } = useOrder()

  return (
    <Overlay style={{ display: orderPadIsOpen ? 'flex' : 'none' }}>
      <Modal>
        <CloseButton type="button" onClick={() => setOrderPadIsOpen(false)}>
          <Icon name="close" />
        </CloseButton>
        <Header>
          <h3>{`Itens do pagamento ${currentOrderPadCard.isUniqueOrderWrapper ? '' : 'parcial'}`}</h3>
        </Header>
        <OrderPad />
        <SubmitButton
          disabled={
            (serviceChargeType === ServiceCharge.COVER && !amountCustomer)
            || isLoadingBilling
          }
          onClick={handlePayOrderPad}
        >
          {isLoadingBilling ? 'Carregando...' : 'Confirmar'}
        </SubmitButton>
      </Modal>
    </Overlay>
  )
}
export default CloseOrderPadModal
